export enum LoaderStep {
    start,
    loading,
    complete,
    error
}
